<template lang="html">
    <section class="add-delivery-address">
        <h1>{{ $t("orders.deliveryAddress.TitleAdd") }}</h1>
        <div class="add-delivery-address-textarea">
            <textarea v-model.trim="deliveryAddressContent" :key="action.id" :class="{ empty: error }" rows="4" cols="40"> </textarea>
        </div>
        <button class="btn btn-client" @click.prevent="hideModal">{{ $t("actions.cancel") }}</button>
        <button class="btn btn-client" @click.prevent="deliveryAdressAdd();">{{ $t("orders.deliveryAddress.btnAdd") }}</button>
    </section>
</template>

<script lang="js">
import {mapActions} from 'vuex'

export default {
    name: 'add-delivery-address',
    props: [
        'action'
    ],
    mounted () {

    },
    data () {
        return {
            deliveryAddressContent: "",
            error: false
        }
    },
    methods: {
        ...mapActions("order", {
            addDeliveryAddress: "details/addDeliveryAddress"
        }),
        deliveryAdressAdd() {
            if (this.deliveryAddressContent) {
                let ObjDataDeliveryAddress = {
                    "deliveryAddress" : {
                        "id" : null,
                        "content": this.deliveryAddressContent
                    }
                }
                try {
                    this.error = false
                    this.addDeliveryAddress(ObjDataDeliveryAddress)
                    this.$root.$emit('bv::hide::modal', 'defaultModal')
                }
                catch (e) {
                    console.log(e);
                }
            } else {
                this.error = true
            }
        },
        /**
         * Function hide Modal
         */
        hideModal: function () {
            this.$root.$emit('bv::hide::modal', 'defaultModal')
        }
    },
    computed: {}
}
</script>
<style lang="scss" scoped>
.add-delivery-address {
    &-textarea {
        margin-bottom: 20px;
        textarea {
            &.empty {
                border: 1px solid red;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// AddDeliveryAddress.vue?ad81d9a4